import React, { useEffect, useRef, useState } from "react";
import { Group, Rect, Image } from "react-konva";
import useImage from "use-image";

function Icon({
  id,
  x,
  y,
  listening,
  color,
  scale,
  onClick,
  selected,
  draggable,
  updatePointCoords,
  canvasWidth,
  canvasHeight,
  canvasScale,
  iconUrl,
  disabled,
  opacity = 1,
}) {
  const [image, setImage] = useState();
  const DEBUG = false;

  const groupRef = useRef();

  const fallback =
    "data:image/svg+xml;base64," +
    window.btoa(`<?xml version="1.0" encoding="utf-8"?>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 582.9 582.9" xml:space="preserve">
      <path fill="#1c1c1c"
        d="M443.9 494.7c28.1 0 50.8-22.8 50.8-50.8v-305c0-28.1-22.8-50.8-50.8-50.8h-305c-28.1 0-50.8 22.8-50.8 50.8v304.9c0 28.1 22.8 50.8 50.8 50.8l305 .1z" />
      <path fill="#fff"
        d="M227.5 242c-3.4 0-6.2-2.7-6.2-6v-.3c2.4-43.8 38.3-59.1 71.1-59.1 36.1 0 69.1 18.9 69.1 57.9 0 27.9-16.4 41.2-32.2 53.2-19.1 14.5-26.1 19.9-26.1 38.4v2.7c0 3.6-2.9 6.5-6.5 6.5h-20.9c-3.5 0-6.4-2.8-6.5-6.4l-.1-5.6c-1-24 12.8-38.7 30.2-51.4 15.3-11.5 25-19 25-35.4 0-21.3-16.2-30.2-34-30.2-20.8 0-32.4 12.4-34.7 29.3-.5 3.5-3.3 6.5-6.9 6.5l-21.3-.1zM287.6 406.3c-13.7 0-23.7-9.2-23.7-21.7 0-12.9 10-22 23.7-22 14.3 0 24.1 9.1 24.1 22 0 12.5-9.8 21.7-24.1 21.7z" />
    </svg>`);

  const [fallbackIcon] = useImage(fallback);

  useEffect(() => {
    const imageToLoad = new window.Image();
    if (iconUrl) {
      imageToLoad.src = iconUrl;
      imageToLoad.addEventListener(
        "load",
        () => {
          setImage(imageToLoad);
        },
        { once: true }
      );
    } else {
      setImage(null);
    }
  }, [iconUrl]);

  // TODO: this isn't always working for the right border of the canvas
  const checkBoundaries = () => {
    if (groupRef.current.x() < -0.15 * scale) groupRef.current.x(-0.15 * scale);
    else if (groupRef.current.x() > canvasWidth / canvasScale.x - 0.85 * scale)
      groupRef.current.x(canvasWidth / canvasScale.x - 0.85 * scale);
    if (groupRef.current.y() < -0.15 * scale) groupRef.current.y(-0.15 * scale);
    else if (groupRef.current.y() > canvasHeight / canvasScale.x - scale + 0.15 * scale)
      groupRef.current.y(canvasHeight / canvasScale.x - scale + 0.15 * scale);
  };

  return (
    <Group
      ref={groupRef}
      x={x - scale / 2}
      y={y - scale / 2}
      listening={listening}
      onClick={onClick}
      draggable={draggable}
      onDragStart={() => {}}
      onDragEnd={() => {
        checkBoundaries();
        // when moving Konva nodes, we need to call the x() and y() functions to get the
        // updated coordinates so that we can send those to the React state
        updatePointCoords(id, {
          x: groupRef.current.x() + scale / 2, // adjusting for the scale of the coaching point icon
          y: groupRef.current.y() + scale / 2,
        });
      }}
      opacity={opacity}
    >
      <Image image={image || fallbackIcon} width={scale} height={scale} opacity={disabled ? 0.2 : 1} />
      <Rect
        name="point"
        x={0.15 * scale}
        y={0.15 * scale}
        width={0.7 * scale}
        height={0.7 * scale}
        fill={"red"}
        selected={selected}
        opacity={DEBUG && selected ? 0.5 : 0}
      />
    </Group>
  );
}

export default Icon;
